import { useTranslation } from "react-i18next";
import { usePermissionsMap } from "@/hooks/usePermissionsMap";
import { useDaycareHotelAccess } from "@/hooks/useDaycareHotelAccess";
import DaycareCapacitySection from "../accommodations/DaycareCapacitySection";
import StayPacksSection from "../accommodations/StayPacksSection";
import HotelSpacesSection from "../accommodations/HotelSpacesSection";
import type { StayTabProps } from "./types";

/**
 * Everything daycare first (capacity, then packs), then overnight, then hotel —
 * each section only renders for a module the clinic actually has.
 */
export default function AccommodationsTab(_props: StayTabProps) {
  const { t } = useTranslation("daycareHotel");
  const { hasDaycare, hasHotel, isLoading } = useDaycareHotelAccess();
  const { data: permissions } = usePermissionsMap();

  const daycare = permissions?.daycare;
  const hotel = permissions?.hotel;

  if (isLoading) {
    return <div className="py-10 text-center text-muted-foreground">{t("common.loading")}</div>;
  }

  if (!hasDaycare && !hasHotel) {
    return <div className="py-10 text-center text-muted-foreground">{t("accommodationsEmpty")}</div>;
  }

  return (
    <div className="flex flex-col gap-8 py-2">
      {hasDaycare ? (
        <>
          <DaycareCapacitySection canEdit={daycare?.update === true} />
          <StayPacksSection
            canEdit={daycare?.update === true}
            canCreate={daycare?.create === true}
            canDelete={daycare?.delete === true}
          />
        </>
      ) : null}

      {hasHotel ? (
        <HotelSpacesSection
          canEdit={hotel?.update === true}
          canCreate={hotel?.create === true}
        />
      ) : null}
    </div>
  );
}
